
import { defineComponent } from 'vue';
import { auth } from '@/firebase/init';
import { signOut } from 'firebase/auth';
import CurrentProductInfo from '../components/CurrentProductInfo.vue';
import authStore, { FirebaseAuth } from '@/firebase/auth';
import { sendPasswordResetEmail } from 'firebase/auth';
export default defineComponent({
  name: 'SettingsPage',
  components: {
    CurrentProductInfo
  },
  data(): {
    authStore: undefined | FirebaseAuth;
    resetText: string;
  } {
    return {
      authStore: undefined,
      resetText: ''
    };
  },
  mounted() {
    this.authStore = authStore;
  },
  methods: {
    goToProjectsPage(): void {
      this.$router.push('/projectManager');
    },
    doSignOut(): void {
      signOut(auth)
        .then(() => {
          this.$router.push('/login');
        })
        .catch((error) => {});
    },
    async sendResetEmail() {
      if (
        !this.authStore ||
        !this.authStore.email ||
        this.authStore.email.trim() === ''
      ) {
        this.resetText =
          'Password reset failed to send: No email address found';
        return;
      }
      try {
        await sendPasswordResetEmail(auth, this.authStore.email);
        this.resetText =
          'Password reset email sent! Please check your email address to reset your password';
      } catch (e) {
        this.resetText = `Password reset failed to send: ${e}`;
      }
    }
  }
});
